import React, { Component } from 'react'
import { BackTop } from 'antd'

import './album-common.css'

class AlbumFooter extends Component {
    render() {
        return (
            <footer className="text-muted">
                <div className="container">
                    <p>Copyright &copy; 2022 <a href="https://www.tut.edu.tw/">台南應用科技大學 Tainan University of Technology</a></p>
                    <p>校址：710302台南市永康區中正路529號 No.529, Zhongzheng Rd., Yongkang District, Tainan City 710302, Taiwan (R.O.C.)</p>
                    <p>│ 電話：+886-6-2532106 │ 傳真：+886-6-2540702</p>
                    <p>│ 系統設計：網路與資訊中心 曾秋榮先生 分機 #261</p>
                </div>
                <BackTop>
                    <div className="goTop" style={{color: "green"}}><i className="fas fa-arrow-circle-up"></i></div>
                </BackTop>
            </footer>
        )
    }
}

export default AlbumFooter